import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import style from './style.scss'

type Props = {
  titleText: string
  bodyText: string
}

function LoginOrCreateAccountHeader({ titleText, bodyText }: Props) {
  return (
    <>
      <HeadlineTwo>{titleText}</HeadlineTwo>
      <TextBlock className={style.text}>{bodyText}</TextBlock>
    </>
  )
}

export default LoginOrCreateAccountHeader
